<template>
  <div class="flex h-16 items-center">
    <FormattedMessage
      class="text-static-default-low body-2 flex items-center"
      :definition="translations.protectedWith"
      tag="div"
    >
      <template #logo>
        <RevIllustration
          alt="BackUp logo"
          class="ml-4 mt-1"
          :height="16"
          src="/img/insurance/backUpLogo.svg"
          :width="72"
        />
      </template>
    </FormattedMessage>

    <div v-if="withLink" class="ml-auto flex items-center">
      <RevLink
        class="body-2-link"
        :tracking="{
          name: 'how_does_it_work',
          zone: trackingZone,
        }"
        @click="handleLinkClicked"
      >
        {{ i18n(translations.learnMore) }}
      </RevLink>

      <ClientOnly>
        <InsurancePremiumDrawer
          v-if="hasBackupPlusOffers"
          :name="MODAL_NAMES.LEARN_MORE.INSURANCE_PREMIUM_MODAL"
        />

        <ServiceDrawer
          v-else-if="hasServicesOffers"
          :name="MODAL_NAMES.LEARN_MORE.SERVICE_MODAL"
        />

        <InsuranceDrawer
          v-else
          :name="MODAL_NAMES.LEARN_MORE.INSURANCE_MODAL"
        />
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/insurance/constants'

import translations from './InsuranceProvider.translations'
import InsuranceDrawer from './components/InsuranceDrawer/InsuranceDrawer.vue'
import InsurancePremiumDrawer from './components/InsurancePremiumDrawer/InsurancePremiumDrawer.vue'
import ServiceDrawer from './components/ServiceDrawer/ServiceDrawer.vue'

const props = defineProps<{
  trackingZone: string
  withLink?: boolean
  hasBackupPlusOffers: boolean
  hasServicesOffers: boolean
}>()

const i18n = useI18n()

function handleLinkClicked() {
  if (props.hasBackupPlusOffers) {
    openModal(MODAL_NAMES.LEARN_MORE.INSURANCE_PREMIUM_MODAL)

    return
  }

  if (props.hasServicesOffers) {
    openModal(MODAL_NAMES.LEARN_MORE.SERVICE_MODAL)

    return
  }

  openModal(MODAL_NAMES.LEARN_MORE.INSURANCE_MODAL)
}
</script>
